/**
 * Centralized error and success messages
 */

export const ERROR_MESSAGES = {
  // Required field errors
  REQUIRED_FIELD: (fieldName) => `${fieldName} is required`,
  
  // Personal information errors
  FIRST_NAME_REQUIRED: "First Name is required",
  LAST_NAME_REQUIRED: "Last Name is required",
  EMAIL_REQUIRED: "Email Address is required",
  PHONE_REQUIRED: "Phone Number is required",
  DOB_REQUIRED: "Date of Birth is required",
  GENDER_REQUIRED: "Gender is required",
  NATIONALITY_REQUIRED: "Nationality is required",
  
  // Validation errors
  INVALID_EMAIL: "Invalid email format",
  INVALID_PHONE: "Invalid phone number for selected country",
  MIN_AGE: (age) => `You must be at least ${age} years old`,
  MAX_AGE: (age) => `Age cannot exceed ${age} years`,
  
  // Address errors
  ADDRESS_REQUIRED: (type) => `${type} Address is required`,
  CITY_REQUIRED: "City is required",
  STATE_REQUIRED: "State is required",
  COUNTRY_REQUIRED: "Country is required",
  ZIP_CODE_REQUIRED: "Zip Code is required",
  
  // File upload errors
  FILE_SIZE: (maxSize) => `File size must be less than ${maxSize}MB`,
  FILE_TYPE: (allowedTypes) => `Invalid file type. Allowed: ${allowedTypes}`,
  FILE_UPLOAD_FAILED: "File upload failed. Please try again",
  NO_FILE_PROVIDED: "No file provided",
  
  // Education errors
  DEGREE_REQUIRED: "Degree is required",
  FIELD_OF_STUDY_REQUIRED: "Field of Study is required",
  GRADUATION_YEAR_REQUIRED: "Graduation Year is required",
  INSTITUTION_REQUIRED: "Institution Name is required",
  CERTIFICATE_REQUIRED: "Certificate upload is required",
  
  // Professional experience errors
  ORGANIZATION_REQUIRED: "Organization Name is required",
  DESIGNATION_REQUIRED: "Designation is required",
  RESPONSIBILITIES_REQUIRED: "Responsibilities are required",
  
  // Recommendation errors
  REFEREE_NAME_REQUIRED: "Referee Name is required",
  REFEREE_EMAIL_REQUIRED: "Referee Email is required",
  REFEREE_PHONE_REQUIRED: "Referee Phone Number is required",
  REFEREE_DESIGNATION_REQUIRED: "Referee Designation is required",
  REFEREE_INSTITUTION_REQUIRED: "Referee Institution is required",
  RECOMMENDATION_LETTER_REQUIRED: "Recommendation Letter is required",
  
  // Fellowship errors
  PROGRAM_REQUIRED: "Fellowship Program is required",
  THEMES_REQUIRED: "At least one theme must be selected",
  THEMES_MAX: (max) => `Maximum ${max} themes can be selected`,
  OTHERS_FIELD_REQUIRED: "Please specify the other theme",
  BOOK_PROPOSAL_REQUIRED: "Book Proposal is required",
  WRITING_SAMPLE_REQUIRED: "Writing Sample is required",
  
  // Additional information errors
  TERMS_REQUIRED: "You must accept the terms and conditions",
  
  // API errors
  SAVE_FAILED: "Failed to save application. Please try again",
  SUBMIT_FAILED: "Failed to submit application. Please try again",
  FETCH_FAILED: "Failed to fetch data. Please try again",
  NETWORK_ERROR: "Network error. Please check your connection",
  SERVER_ERROR: "Server error. Please try again later",
  UNAUTHORIZED: "Unauthorized. Please login again",
  
  // Form errors
  FORM_INCOMPLETE: "Please fill all required fields",
  DOCUMENT_UPLOAD_REQUIRED: "Please upload the required document to enable the form",
};

export const SUCCESS_MESSAGES = {
  SAVED: "Application saved successfully!",
  SUBMITTED: "Application submitted successfully!",
  UPLOADED: "File uploaded successfully!",
  UPDATED: "Information updated successfully!",
  EMAIL_SENT: "Email sent successfully!",
  VERIFICATION_SENT: "Verification email sent successfully!",
};

export const INFO_MESSAGES = {
  LOADING: "Loading...",
  SAVING: "Saving...",
  UPLOADING: "Uploading...",
  SUBMITTING: "Submitting...",
  PROCESSING: "Processing...",
  PLEASE_WAIT: "Please wait...",
  UPLOAD_DOCUMENT_PROMPT: "Please upload the required document to enable the form.",
};
